module.exports = __webpack_public_path__ + "img/service-cart-welcome.5092358d.png";